<div class="qa-grid mm-page">
  <h2 class="mb-4">{{_(KEYS.GRID.CUSTOM_FIELDS)}}</h2>

  <!-- Search Card -->
  <div class="card mb-5">
    <div class="card-body">
      <button type="button" class="card-title mm-pane-toggle"
              (click)="isSearchCollapsed = !isSearchCollapsed"
              [attr.aria-expanded]="!isSearchCollapsed" aria-controls="settings-client-custom-grid-search-fields">
        <span class="mm-pane-toggle-label">
          <i class="fa fa-search" aria-hidden="true"></i>
          <span>{{_(KEYS.GRID.SEARCH)}}</span>
        </span>
        <span class="mm-pane-toggle-icon" aria-hidden="true">
          <i class="fa" [ngClass]="{'fa-chevron-down': isSearchCollapsed, 'fa-chevron-up': !isSearchCollapsed}"></i>
        </span>
      </button>
      <div id="settings-client-custom-grid-search-fields" class="card-text" [ngbCollapse]="isSearchCollapsed">
        <div class="search-grid">
          <div class="search-field">
            <label>{{_(KEYS.GRID.KEY)}}</label>
            <input class="form-control" [(ngModel)]="filter.key"
                   (paste)="onFilterChange()" (change)="onFilterChange()" (keydown)="onFilterChange()">
          </div>
          <div class="search-field">
            <label>{{_(KEYS.GRID.LABEL)}}</label>
            <input class="form-control" [(ngModel)]="filter.label"
                   (paste)="onFilterChange()" (change)="onFilterChange()" (keydown)="onFilterChange()">
          </div>
          <div class="search-field">
            <label>{{_(KEYS.GRID.TYPE)}}</label>
            <select class="form-control custom-select" [(ngModel)]="filter.type" (change)="onFilterChange()">
              <option value="">--</option>
              <option value="text">{{_(KEYS.CRUD.TYPE_TEXT)}}</option>
              <option value="number">{{_(KEYS.CRUD.TYPE_NUMBER)}}</option>
              <option value="date">{{_(KEYS.CRUD.TYPE_DATE)}}</option>
              <option value="select">{{_(KEYS.CRUD.TYPE_SELECT)}}</option>
              <option value="boolean">{{_(KEYS.CRUD.TYPE_BOOLEAN)}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Grid Card -->
  <div class="card">
    <div class="card-body">
      <div class="card-title mm-pane-header" [class.mm-pane-collapsed]="isGridCollapsed">
        <div class="mm-pane-actions">
          <button class="btn btn-sm btn-success d-inline-block" (click)="onRefresh()">
              <i class="fa fa-refresh"></i>
            </button>
        </div>
        <button type="button" class="mm-pane-toggle"
                (click)="isGridCollapsed = !isGridCollapsed"
                [attr.aria-expanded]="!isGridCollapsed" aria-controls="settings-client-custom-grid-results">
          <span class="mm-pane-toggle-label"><span>{{_(KEYS.GRID.CUSTOM_FIELDS)}}</span></span>
          <span class="mm-pane-toggle-icon" aria-hidden="true">
            <i class="fa" [ngClass]="{'fa-chevron-down': isGridCollapsed, 'fa-chevron-up': !isGridCollapsed}"></i>
          </span>
        </button>
      </div>
      <div id="settings-client-custom-grid-results" class="card-text" [ngbCollapse]="isGridCollapsed">
        <div class="mm-table-scroll"><table class="table">
          <thead>
          <tr>
            <th class="id-col">{{_(KEYS.GRID.ID)}}</th>
            <th>{{_(KEYS.GRID.KEY)}}</th>
            <th>{{_(KEYS.GRID.LABEL)}}</th>
            <th>{{_(KEYS.GRID.TYPE)}}</th>
            <th>{{_(KEYS.GRID.REQUIRED)}}</th>
            <th>{{_(KEYS.GRID.CREATED_AT)}}</th>
            <th>{{_(KEYS.GRID.UPDATED_AT)}}</th>
            <th>{{_(KEYS.GRID.ACTIONS)}}</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let definition of getDefinitions(); let pos = index;">
            <tr [ngClass]="{'qa-tr-odd': pos % 2 === 0}">
              <td class="id-col">
                <span ngbTooltip="{{definition.uid}}">{{definition.uid | truncate: 5}}</span>
              </td>
              <td>{{definition.key}}</td>
              <td>{{definition.label}}</td>
              <td>{{getTypeLabel(definition.type)}}</td>
              <td>
                <i class="fa" [ngClass]="{'fa-check': definition.required, 'fa-times': !definition.required}"></i>
              </td>
              <td>{{definition.createdAt | datex:dateFormat}}</td>
              <td>{{definition.updatedAt | datex:dateFormat}}</td>
              <td>
                <div class="d-inline-block nowrap">
                  <div
                    class="btn btn-primary mr-1"
                    (click)="onEditDefinition(definition)"
                    data-toggle="tooltip"
                    data-placement="top"
                    [title]="_(KEYS.GRID.CHANGE)">
                    <i class="fa fa-edit qa-cursor-pointer"></i>
                  </div>
                  <div
                    class="btn btn-danger"
                    (click)="onDeleteDefinition(definition)"
                    data-toggle="tooltip"
                    data-placement="top"
                    [title]="_(KEYS.GRID.DELETE)">
                    <i class="fa fa-trash qa-cursor-pointer"></i>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table></div>
        <div class="btn-toolbar justify-content-between mt-2 mb-2">
          <div class="justify-content-between">
            <div class="input-group">
              <div class="input-group qa-num-per-page">
                <select class="form-control custom-select" [(ngModel)]="displayPerPage" (change)="onPagingChange()">
                  <option value="2">2</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span class="input-group-addon">{{_(KEYS.GRID.ENTRIES)}}</span>
              </div>

              <button
                class="btn btn-primary ml-1"
                (click)="onCreateDefinition()"
                data-toggle="tooltip"
                data-placement="top"
                title="{{_(KEYS.GRID.CREATE)}}">
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
          <ngb-pagination
            [pageSize]="displayPerPage"
            [maxSize]="9"
            [rotate]="true"
            [(page)]="gridPageNumber"
            [collectionSize]="total"
            (pageChange)="onPagingChange()">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
